import { OverlayPanel } from "primereact/overlaypanel";

import styles from "./search-menu.module.scss";
import type { SearchMenuViewProps } from "./types-search-menu";

/**
 * Menu popup com busca (Figma `_tieredmenu` 9129:353250 e 7711:92204): o `OverlayPanel` do Prime com o conteúdo
 * dentro; `Search`, `List`, `Item` e `Empty` o desenham.
 */
export function SearchMenuView({
  panel,
  appendTo,
  panelClassName,
  onShow,
  onHide,
  testId,
  className,
  style,
  rest,
  children,
}: SearchMenuViewProps) {
  return (
    <OverlayPanel
      ref={panel}
      className={[styles.panel, panelClassName].filter(Boolean).join(" ")}
      pt={{ content: { className: styles.content } }}
      appendTo={appendTo}
      dismissable
      closeOnEscape
      onShow={onShow}
      onHide={onHide}
    >
      <div
        className={[styles.root, className].filter(Boolean).join(" ")}
        style={style}
        data-testid={testId}
        {...rest}
      >
        {children}
      </div>
    </OverlayPanel>
  );
}
